// Dependencies
require("section/newsletter-form");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/newsletter-form/index.js
 ** module id = 184
 ** module chunks = 0 1
 **/